import React from "react";
import {
  Grid,
  TableBody,
  TableContainer,
  CardContent,
  Divider,
  Card,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import {  readableFormatDate } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";

export const NachDetails = ({ data }) => {
  return (
    <Card>
      <CardContent className="card-content_head">
        <Grid container alignItems="center">
          <Grid item xs={6}>
            Nach Details
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <CustomTableWrapper>
          <Grid item lg={6} md={6} sm={6} xs={12}>
          <TableContainer className="common_X_scroll">
            <table className="w-full">
              <TableBody>
                <TableBodyCell className="common_table_title">Is Bounce</TableBodyCell>
                <TableBodyCell>
                  {" "}
                  <BootstrapBadge
                    backgroundColor="#FF4961"
                    text={data["is_bounce"] === 1 ? "Yes" : "No"}
                  />
                </TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Comment</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["comment"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Added By Subuser</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["added_by_subuser_id"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Added By Subuser Datetime</TableBodyCell>
                <TableBodyCell className="common_table_content">{readableFormatDate( data["added_by_subuser_id_datetime"])}</TableBodyCell>
              </TableBody>

              <TableBody>
                <TableBodyCell className="common_table_title">Status</TableBodyCell>
                <TableBodyCell>
                  <BootstrapBadge
                    backgroundColor="#0ABB87"
                    text={data["status"]}
                  />
                </TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Nach Presentation Date</TableBodyCell>
                <TableBodyCell className="common_table_content">{readableFormatDate(data["nach_presentation_date"])}</TableBodyCell>
              </TableBody>
            </table>
            </TableContainer>
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
          <TableContainer className="common_X_scroll">
            <table className="w-full">
              <TableBody>
                <TableBodyCell className="common_table_title">Bank Transaction Id</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["bank_transaction_id"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Mandate Reference Number</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["mandate_reference_number"]}</TableBodyCell>
              </TableBody>

              <TableBody>
                <TableBodyCell className="common_table_title">Partner Payment Id</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["partner_payment_id"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Receiving Bank Account</TableBodyCell>
                <TableBodyCell className="common_table_content">-</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                <TableBodyCell className="common_table_content">{readableFormatDate(data["created_at"]) }</TableBodyCell>
              </TableBody>
            </table>
            </TableContainer> 
          </Grid>
        </CustomTableWrapper>
      </CardContent>
    </Card>
  );
};
